export class GetDealActivities {
    public static type = '[DealActivities] GetDealActivities';
    constructor(
      public dealId: number,
    ) {}
  }